import React, { Component } from "react";
import img1 from '../../images/1.jpg';
import img2 from '../../images/2.jpg';
import img3 from '../../images/3.jpg';
import img4 from '../../images/4.jpg';
import img5 from '../../images/5.jpg';
import img6 from '../../images/6.jpg';
import img7 from '../../images/7.jpg';
import img8 from '../../images/8.jpg';
import img9 from '../../images/9.jpg';
import img11 from '../../images/9.jpg';
import img12 from '../../images/9.jpg';
import img13 from '../../images/9.jpg';
import img14 from '../../images/9.jpg';
import img15 from '../../images/9.jpg';
import '../../css/plugins.css';
import '../../style.css';
type Props = {};
type State = {};

class Proyecto extends Component<Props, State> {

  render() {
    return (
      <React.Fragment>
        <main id="page-content">

          <div className="cr-breadcrumb-area bg-breadcrumb-1 title-page" data-overlay="7">
            <div className="container">
              <div className="cr-breadcrumb">
                <h2>PROYECTOS</h2>
              </div>
            </div>
          </div>

          <section className="cr-section blogs-area bg-grey section-padding-md">
            <br></br><br></br>
            <div className="container">

              <div className="row blog-item-slider-active slider-navigation-style-1">

                <div className="col-lg-4">
                  <div className="blog-item">
                    <a className="blog-item-thumb">
                      <img src={img1}></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Obra: Empacadora de piña, Tabafresh.</a></h5>
                      <p>Participación: Diseño, construcción y equipamiento de cámaras de conservación, (Llave en mano por medio de alianza estratégica).</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector industrial</span>
                        <span><a ><i className="fa fa-map-marker"></i> Huimanguillo, Tabasco.</a></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img2} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Obra: Empacadora de jitomate, DAISE.</a></h5>
                      <br></br>
                      <p>Participación: (Llave en Mano).</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector agroindustrial</span>
                        <span><a ><i className="fa fa-map-marker"></i> Ixtapaluca, Estado de México</a></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img3} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Centro de Distribución Sigma Alimentos Guadalajara</a></h5>
                      <br></br>
                      <p>Proyecto llave en Mano</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector cárnico</span>
                        <span><a ><i className="fa fa-map-marker"></i> Guadalajara, Jalisco.</a></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img4} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>SIGMA ALIMENTOS</a></h5>
                      <p>Obra: Proyecto llave en mano</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Centro de Distribución Refrigerado</span>
                        <span><a ><i className="fa fa-map-marker"></i> Querétaro, Querétaro</a></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img5} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Planta de fabricación de nebulizadores</a></h5>
                      <p>Participación: Proyecto Llave en Mano.</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector farmacéutico</span>
                        <span><a ><i className="fa fa-map-marker"></i>NEB</a></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img6} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Mini bodegas Qualistar</a></h5>
                      <p>Participación: Proyecto llave en mano, Dimensiones 4000 m2</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector industrial</span>
                        <span><a ><i className="fa fa-map-marker"></i> Cuamatla, Estado de México</a></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img7} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Remodelación de oficinas, ALSEA/SUMA.</a></h5>
                      <p>Participación: Proyecto llave en mano.</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector industrial</span>
                        <span><a ><i className="fa fa-map-marker"></i> Tláhuac Méx. D. F.</a></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img8} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Bodega Aurrera Express, Wal-Mart.</a></h5>
                      <p>Participación: Subcontrato. Desde Terracerias hasta entrega final de la Tienda (Llave en mano).</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector comercial</span>
                        <span><a ><i className="fa fa-map-marker"></i>Ixtapaluca, Estado de México.</a></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img9} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Almacén de equipo</a></h5>
                      <p>Participación: Subcontrato. Rack auto portante, laminación de muros y cubierta. Dimensiones: 30.00 x 60.00 mts con una altura de 8.00 mts.</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector industrial</span>
                        <span><a ><i className="fa fa-map-marker"></i>OCESA Iztacalco, México D. F.</a></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img11} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Campamento, GOLD CORP.</a></h5>
                      <p>Participación: Subcontrato. Muros y cubiertas con panel térmico.</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector industrial</span>
                        <span><a ><i className="fa fa-map-marker"></i>Mezcala, Guerrero.</a></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img12} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Ultra Congelados Be Frost.</a></h5>
                      <p>Participación: Proyecto ejecutivo, terracerías, obra civil y pisos.</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector industrial</span>

                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img13} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Ultra Congelados Be Frost.</a></h5>
                      <p>Participación: Proyecto ejecutivo, terracerías, obra civil y pisos.</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector industrial</span>

                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img14} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Cambio de Cubierta en Mercado Cabecera Municipal</a></h5>
                      <p>Participación: Proyecto, logística, desmantelamiento de cubierta y estructura existente, fabricación y montaje de estructura nueva y cubierta con arco auto portante, trabajos realizados con mercado en funcionamiento.</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Obra pública</span>
                        <span><a ><i className="fa fa-map-marker"></i>H Ayuntamiento de Naucalpan</a></span>

                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-item">
                    <a href="blog-details.html" className="blog-item-thumb">
                      <img src={img15} alt="blog image"></img>
                    </a>
                    <div className="blog-item-content">
                      <h5 className="blog-item-title"><a>Domo, Preparatoria Oficial 83.</a></h5>
                      <p>Participación: Diseño, cimentación, estructura y cubierta. (Llave en Mano).</p>
                      <div className="blog-item-meta">
                        <span><i className="fa fa-tag"></i>Sector institucional</span>
                        <span><a ><i className="fa fa-map-marker"></i>Teoloyucan, Estado de México.</a></span>

                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </React.Fragment>
    );
  }
}

export default Proyecto;
